module.exports = "<input (keyup)=\"searchTerm$.next($event.target.value)\" placeholder=\"{{ 'FORMS.SEARCH' | translate }}\" [disabled]=\"isDisabled\" [ngClass]=\"{'disabled': isDisabled}\"/>\r\n<!-- <input (keyup)=\"onKeySearchInput($event)\" placeholder=\"{{ 'FORMS.SEARCH' | translate }}\"/> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search/search.component.html
// module id = ./src/app/shared/components/search/search.component.html
// module chunks = main